import { MessageSquareMore } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const MessageSquareMoreIcon = createLucideIcon(MessageSquareMore);
